/** @format */

import * as actionTypes from "./../types";
import { apiError } from "../../utils/GTMDataLayer";
// import { logger } from "cbt-sdk";
import { logger } from "@goldenbird1/ui-logger-library";
import Router from "next/router";
import { v4 as uuidv4 } from "uuid";
let retryCount = 0;
let retryCountSD = 0;
let retryCountSPLPDetails = 0;

export const setListingPageLoading = (isLoading) => {
  return {
    type: actionTypes.GET_LISTING_PAGE_LOADING,
    payload: {
      isLoading: isLoading,
    },
  };
};

export const setListingPage = (count, content) => {
  return {
    type: actionTypes.GET_LISTING_PAGE,
    payload: {
      count: count,
      content: content,
    },
  };
};

export const setSellerDetails = (sellerDetails) => {
  return {
    type: actionTypes.GET_SELLER_DETAILS,
    payload: {
      sellerDetails: sellerDetails,
    },
  };
};

export const setProductDetails = (productDetails) => {
  return {
    type: actionTypes.GET_PRODUCT_DETAILS,
    payload: {
      productDetails: productDetails,
    },
  };
};

export const setError500 = (error) => {
  return {
    type: actionTypes.SET_ERROR500,
    payload: {
      isError500: error
    },
  };
};

export const setErrorStatus = () => {
  return (dispatch) => {
    dispatch(setError500(true));
  };
};

export const setSLPDetails = (
  totalHits,
  sellerHomeLiteViews,
  aggregates,
  categories
) => {
  return {
    type: actionTypes.GET_SLP_DETAILS,
    payload: {
      slp_count: totalHits,
      slp_content: sellerHomeLiteViews,
      slp_facets: aggregates,
      slp_categories: categories,
    },
  };
};

export const setListingPageFailed = (error) => {
  return {
    type: actionTypes.GET_LISTING_PAGE_FAILED,
    payload: {
      error: error,
    },
  };
};

export const setSentViewedProductsToGA = (data) => {
  return {
    type: actionTypes.SET_VIEWED_PRODUCT_DETAILS,
    payload: {
      viewedProducts: data,
    }
  }
};

export const setViewedProducts = (input) => (dispatch) => {
  dispatch(setSentViewedProductsToGA(input));
}

export const getSLPDetails = (
  queryResult,
  loader = false,
  prevStateData = false,
  callback = false
) => {
  let buyerId = localStorage.getItem('userid') ? localStorage.getItem('userid') : null;
  return (dispatch) => {
    if (loader) dispatch(setListingPageLoading(true));
     let url = process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL +
        "/search/v1/seller-listing?" +
        queryResult;

    return fetch(url, {
      method: "GET",
      headers: {
        "trace-id": uuidv4(),
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          apiError(
            "getSLPDetails",
            res.statusText || "Error while fetching seller listing details.",
            "GET",
            "sellerListing"
          );
          throw res;
        }
      })
      .then((result) => {
        let {
          totalHits = 0,
          sellerHomeLiteViews = [],
          aggregates = [],
          fixedAggregates = {},
        } = result;
        dispatch(setListingPageLoading(false));
        if (callback) {
          callback(result);
        }
        if (prevStateData) {
          let newStateData = [...prevStateData, ...sellerHomeLiteViews];
          return dispatch(
            setSLPDetails(totalHits, newStateData, aggregates, fixedAggregates)
          );
        } else {
          return dispatch(
            setSLPDetails(
              totalHits,
              sellerHomeLiteViews,
              aggregates,
              fixedAggregates
            )
          );
        }
      })
      .catch((error) => {
        logger(
          "error",
          "Error from SLP api: " +
            url +
            ": error => " +
            error.statusText +
            ": buyerId => " +
            buyerId,
          process.env.NEXT_PUBLIC_LOGGER_URL
        );
        apiError("getSLPDetails", error.statusText, "GET", "sellerListing");
        console.log(error);
        dispatch(setListingPageLoading(false));
        if (error.status === 401) {
          Router.push("/signin");
        }
        if (callback) {
          callback(error);
        }
        return dispatch(setListingPageFailed(error));
      });
  };
};

export const getSPLPDetails = (
  queryResult,
  prevStateData = false,
  callback = false
) => {
  let buyerId = localStorage.getItem('userid') ? localStorage.getItem('userid') : null;
  return (dispatch) => {
     let url =
       process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL +
       "/search/v1/seller-product-search?" +
       queryResult;

    return fetch(url, {
      method: "GET",
      headers: {
        "trace-id": uuidv4(),
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          apiError(
            "getSPLPDetails",
            res.statusText || "Error while fetching seller listing details.",
            "GET",
            "sellerListing"
          );
          throw res;
        }
      })
      .then((result) => {
        let {
          totalHits = 0,
          products = [],
          aggregates = [],
          fixedAggregates = {},
        } = result;
        if (prevStateData) {
          let newStateData = [...prevStateData, ...products];
          if (callback) {
            callback({
              totalHits,
              products: newStateData,
              aggregates,
              fixedAggregates,
            });
          }
          return dispatch(
            setSLPDetails(totalHits, newStateData, aggregates, fixedAggregates)
          );
        } else {
          if (callback) {
            callback(result);
          }
          return dispatch(
            setSLPDetails(totalHits, products, aggregates, fixedAggregates)
          );
        }
      })
      .catch((error) => {
        // if(retryCountSPLPDetails < 3){
        //   if(callback){
        //     getSPLPDetails(queryResult, prevStateData, callback);
        //   }else{
        //     getSPLPDetails(queryResult, prevStateData);
        //   }
        // }else{
        //   apiError("getSPLPDetails", error, "GET", "sellerListing");
        //   if (callback) {
        //     callback(error);
        //   }
        //   return dispatch(setListingPageFailed(error));
        // }
        // retryCountSPLPDetails++;
        logger(
          "error",
          "Error from SPLP api: " +
            url +
            " : error => " +
            error.statusText +
            ": buyerId => " +
            buyerId,
          process.env.NEXT_PUBLIC_LOGGER_URL
        );
        apiError("getSPLPDetails", error.statusText, "GET", "sellerListing");
        if (error.status === 401) {
          Router.push("/signin");
        }
        if (callback) {
          callback({ error: true });
        }
        return dispatch(setListingPageFailed(error));
      });
  };
};

export const getListingPage = (token, queryResult, prevStateData = false) => {
  return (dispatch) => {
    dispatch(setListingPageLoading(true));
    let url = process.env.NEXT_PUBLIC_REACT_APP_API_PROFILE_URL +
        "/seller-homev2/?" +
        queryResult;

    return fetch(
      url,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    )
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          apiError(
            "getListingPage",
            res.statusText || "Error while fetching seller listing details.",
            "GET",
            "sellerListing"
          );
          throw res;
        }
      })
      .then((result) => {
        let { count = 0, content = [] } = result;
        dispatch(setListingPageLoading(false));
        if (prevStateData) {
          let newStateData = [...prevStateData, ...content];
          return dispatch(setListingPage(count, newStateData));
        } else {
          return dispatch(setListingPage(count, content));
        }
      })
      .catch((error) => {
        logger("error", "Error from getListingPage api: " + url + " : " + error.statusText, process.env.NEXT_PUBLIC_LOGGER_URL);
        apiError("getListingPage", error.statusText, "GET", "sellerListing");
        if(error.status === 401){
          Router.push('/signin');
        }
        dispatch(setListingPageLoading(false));
        return dispatch(setListingPageFailed(error));
      });
  };
};

export const getSellerDetails = (
  token,
  sellerId,
  verificationStatus = "",
  callback = false
) => {
  let buyerId = localStorage.getItem('userid') ? localStorage.getItem('userid') : null;
  return (dispatch) => {
    let url =
      process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL + "/profile/v1/sellers/" + sellerId  + "/profile";
    if (verificationStatus) {
      url =
        process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL +
        "/profile/v1/sellers/" +
        sellerId +
        "/profile" +
        "?viewerStatus=" +
        verificationStatus;
    }
    dispatch(setListingPageLoading(true));
    return fetch(url, {
      method: "GET",
      headers: {
        Authorization: token
          ? `Bearer ${token}`
          : "Bearer " + process.env.NEXT_PUBLIC_ANONYMOUS_TOKEN,
          'trace-id' : uuidv4()
      },
    })
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        apiError(
          "getSellerDetails",
          res.statusText || "Error while fetching seller listing details.",
          "GET",
          "sellerListing"
        );
        throw res;
      }
    })
    .then((result) => {
      if (callback) {
        callback(result);
      }
      dispatch(setListingPageLoading(false));
      return dispatch(setSellerDetails(result));
    })
    .catch((error) => {
      logger("error", "Error from getSellerDetails api: " + url + " : error => " + error.statusText + ': buyerId => '+ buyerId, process.env.NEXT_PUBLIC_LOGGER_URL);
      if(callback){
        callback({error: "Error while fetching seller listing details"})
      }
      apiError("getSellerDetails", error.statusText, "GET", "sellerListing");
      if(error.status === 401){
        Router.push('/signin');
      }
      dispatch(setListingPageLoading(false));
      return dispatch(setListingPageFailed(error));
    });
  };
};

export const getProductSellerDetails = (token, sellerId) => {
  let buyerId = localStorage.getItem('userid') ? localStorage.getItem('userid') : null;
  return (dispatch) => {
    let url =
      process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL +
      "/profile/v1/seller-home/internal-view?view=SPLP&id=" +
      sellerId;

    // dispatch(setListingPageLoading(true));
    return fetch(url, {
      method: "GET",
      headers: {
        Authorization: token
          ? `Bearer ${token}`
          : "Bearer " + process.env.NEXT_PUBLIC_ANONYMOUS_TOKEN,
        'trace-id' : uuidv4()
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          apiError(
            "getProductSellerDetails",
            res.statusText || "Error while fetching seller listing details.",
            "GET",
            "sellerListing"
          );
          throw res;
        }
      })
      .then((result) => {
        // dispatch(setListingPageLoading(false));
        return dispatch(setSellerDetails(result));
      })
      .catch((error) => {
        logger("error", "Error from getProductSellerDetails api: " + url + " : error => " +error.statusText+ ': buyerId => '+buyerId, process.env.NEXT_PUBLIC_LOGGER_URL);
        apiError("getProductSellerDetails", error.statusText, "GET", "sellerListing");
        if(error.status === 401){
          Router.push('/signin');
        }
        // console.log(error);
        // dispatch(setListingPageLoading(false));
        return dispatch(setListingPageFailed(error));
      });
  };
};

export const getProductDetails = (token, articleId = "", callback = "") => {
  let buyerId = localStorage.getItem('userid') ? localStorage.getItem('userid') : null;
  return (dispatch) => {
    // let url =
    //   process.env.NEXT_PUBLIC_REACT_APP_API_PRODUCT_DESCRIPTION_PRICE_URL +
    //   "/products/" +
    //   articleId;
    let url =
      process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL +
      `/home/v1/price/product/PRODUCT::${articleId}?currency=USD`;
 

    dispatch(setListingPageLoading(true));
    return fetch(url, {
      method: "GET",
      headers: {
        Authorization: token
          ? `Bearer ${token}`
          : "Bearer " + process.env.NEXT_PUBLIC_ANONYMOUS_TOKEN,
        'trace-id' : uuidv4()
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          apiError(
            "getProductDetails",
            res.statusText || "Error while fetching PDP details.",
            "GET",
            "PDP"
          );
          throw res;
        }
      })
      .then((result) => {
        return dispatch(setProductDetails(result[0]));
      })
      .catch((error) => {
        logger("error", "Error PDP: " + url + ' : error => ' + error.statusText + ': buyerId => '+buyerId, process.env.NEXT_PUBLIC_LOGGER_URL);
        if(callback) {
          callback({ error: "There is an error" });
        }
        apiError("getProductDetails failed after 3 retries", error.statusText, "GET", "PDP");
        if(error.status === 401){
          Router.push('/signin');
        }
        dispatch(setProductDetails(error));
        return dispatch(setError500(true));
      });
  };
};

export const getPLPDetails = (
  queryResult,
  loader = false,
  prevStateData = false,
  gb = false,
  callback = false
) => {
  let buyerId = localStorage.getItem('userid') ? localStorage.getItem('userid') : null;
  return (dispatch) => {
    if (loader) dispatch(setListingPageLoading(true));
    let url =
      process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL +
      "/search/v1/product-search?" +
      queryResult;
    if (gb) {
      url =
        process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL +
        "/search/v1/custom-plp?" +
        queryResult;
    }
    return fetch(url, {
      method: "GET",
      headers: {
        'trace-id' : uuidv4()
      }
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          apiError(
            "getPLPDetails",
            res.statusText || "Error while fetching product listing details.",
            "GET",
            "productListing"
          );
          throw res;
        }
      })
      .then((result) => {
        let {
          totalHits = 0,
          products = [],
          aggregates = [],
          fixedAggregates = {},
        } = result;
        dispatch(setListingPageLoading(false));

        if (prevStateData) {
          let newStateData = [...prevStateData, ...products];
          if (callback) {
            callback({
              totalHits,
              products: newStateData,
              aggregates,
              fixedAggregates,
            });
          }
          return dispatch(
            setSLPDetails(totalHits, newStateData, aggregates, fixedAggregates)
          );
        } else {
          if (callback) {
            callback(result);
          }
          return dispatch(
            setSLPDetails(totalHits, products, aggregates, fixedAggregates)
          );
        }
      })
      .catch((error) => {
        logger("error", "Error from PLP api: " + url + ": error => " +error.statusText+ ': buyerId => '+buyerId, process.env.NEXT_PUBLIC_LOGGER_URL);
        apiError("getPLPDetails", error.statusText, "GET", "productListing");
        console.log(error);
        if(error.status === 401){
          Router.push('/signin');
        }
        dispatch(setListingPageLoading(false));
        if (callback) {
          callback({error : true});
        }
        return dispatch(setListingPageFailed(error));
      });
  };
};

export const getThemeData = (
  themeGroup,
  queryResult,
  loader = false,
  prevStateData = false,
  gb = false,
  callback = false
) => {
  return (dispatch) => {
    if (loader) dispatch(setListingPageLoading(true));
    let url =
      process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL +
      `/search/v1/product-search?bird=lion&from=0&size=30&sort_order=DESC&sort_by=popularity&f_themeGroup=${themeGroup}`;
    if(queryResult){
      url =
        process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL +
        `/search/v1/product-search?bird=lion&from=0&size=30&sort_order=DESC&sort_by=popularity&f_themeGroup=${themeGroup}&` +
        queryResult;
 
    }

    return fetch(url, {
      method: "GET",
      headers: {
        "trace-id": uuidv4(),
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          apiError(
            "getPLPThemeData",
            res.statusText || "Error while fetching PLP theme details.",
            "GET",
            "getPLPThemeData"
          );
          throw res;
        }
      })
      .then((result) => {
        let {
          totalHits = 0,
          products = [],
          aggregates = [],
          fixedAggregates = {},
        } = result;
        dispatch(setListingPageLoading(false));

        if (prevStateData) {
          let newStateData = [...prevStateData, ...products];
          if (callback) {
            callback({
              totalHits,
              products: newStateData,
              aggregates,
              fixedAggregates,
            });
          }
          return dispatch(
            setSLPDetails(totalHits, newStateData, aggregates, fixedAggregates)
          );
        } else {
          if (callback) {
            callback(result);
          }
          return dispatch(
            setSLPDetails(totalHits, products, aggregates, fixedAggregates)
          );
        }
      })
      .catch((error) => {
        logger(
          "error",
          "Error from getThemeData api: " + url + " : " + error.statusText,
          process.env.NEXT_PUBLIC_LOGGER_URL
        );
        apiError("getPLPThemeData", error.statusText, "GET", "sellerListing");
        console.log(error);
        if (error.status === 401) {
          Router.push("/signin");
        }
        dispatch(setListingPageLoading(false));
        if (callback) {
          callback(error);
        }
        return dispatch(setListingPageFailed(error));
      });
  };
};
